import React from 'react';
import { shape, instanceOf, func } from 'prop-types';
import DefinitionTableHeader from './DefinitionTableHeader';
import DefinitionTableBody from './DefinitionTableBody';

const DefinitionTable = ({ studyDefinition, setSelectedDefinition }) => {
  const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  };

  setTimeout(() => {
    const hasScroll =
      $('.datahub-table--body').get(0).scrollHeight >
      $('.datahub-table--body').height();
    if (hasScroll) {
      const scrollWidth = getScrollbarWidth();
      $('.datahub-table').addClass('has-scroll');
      $('.datahub-table .datahub-table--head').attr(
        'style',
        `padding-right: ${scrollWidth}px`
      );
    } else {
      $('.datahub-table').removeClass('has-scroll');
      $('.datahub-table .datahub-table--head').removeAttr('style');
    }
  }, 100);
  return (
    <div className="de--def--table de--flex-col de--flex-col-1 de-o-hidden datahub-table">
      <DefinitionTableHeader
        setSelectedDefinition={setSelectedDefinition}
        data={studyDefinition.definitionList}
      />
      <DefinitionTableBody
        data={studyDefinition.definitionList}
        setSelectedDefinition={setSelectedDefinition}
      />
    </div>
  );
};

DefinitionTable.propTypes = {
  studyDefinition: shape({
    definitionList: instanceOf(Object),
  }),
  setSelectedDefinition: func,
};

DefinitionTable.defaultProps = {
  studyDefinition: {
    definitionList: [],
  },
};

export default DefinitionTable;
